import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Foundations'

export const RacingContainerStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
})

export const RacingContentStyled = styled.div<{ disabled: boolean }>(({ disabled }) => ({
  opacity: disabled ? 0.5 : 1,
}))

export const RacingWrapperStyled = styled.div({
  // explicit positioning required for the overlay to reference as an anchor
  position: 'relative',

  // explicit margin required because the absolute position prevents the flexbox from stretching (refer VenueMode.styles.tsx)
  marginTop: spacing.smx1,
  flexGrow: 1,
})

export const RacingOverlayStyled = styled.div({
  // position overlay to completely cover the parent item, i.e. break the document flow
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
})

export const RacingDisabledOverlayStyled = styled(RacingOverlayStyled)({
  // fade the content (in addition to the opacity) by drawing a white background
  background:
    'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.50) 42.46%, #FFF 100%)',
})

export const NotInVenueParentStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.6rem',
  flex: 1,
  //justifyContent: 'center',
  marginTop: spacing.lgx3,
  marginLeft: spacing.lg,
  marginRight: spacing.lg,
})

export const MessageStyled = styled.div({
  fontFamily: font.family.primary,
  fontSize: font.size.lg.fontSize,
  fontWeight: font.weight.semibold,
  color: colors.black,
  textAlign: 'center',
})
